import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "質問一覧")
], -1)
const _hoisted_3 = { class: "d-grid d-md-flex justify-content-md-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新規登録")
const _hoisted_5 = {
  key: 0,
  scope: "col",
  style: {"width":"30px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "種別", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "質問", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "結果", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "手続き", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"60px"}
}, "手続き種別", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"60px"}
}, "編集", -1)
const _hoisted_12 = ["rowspan"]
const _hoisted_13 = ["rowspan"]
const _hoisted_14 = ["rowspan"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["rowspan"]
const _hoisted_18 = {
  key: 1,
  class: "d-grid d-md-flex justify-content-md-start"
}
const _hoisted_19 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("戻る")

import { inject, ref, unref } from 'vue'
import { useMessenger } from '@/plugins/message'
import draggable from 'vuedraggable'
import IconUpDownLeftRight from '@/components/ui/IconUpDownLeftRight.vue'
import IconPenToSquare from '@/components/ui/IconPenToSquare.vue'
import ConciergeHeaderQuestion from "@/components/parts/ConciergeHeaderQuestion.vue"
import {injectKey, Nicotto, ConciergeSection, ConciergeCategory, ConciergeQuestion} from '@/plugins/nicotto'
import { onBeforeRouteLeave } from "vue-router";
import ButtonLink from "@/components/ui/ButtonLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  props: {
    categoryId: null,
    sectionId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
  sectionId: string
}


const isDraggable = ref(false)
const nicotto = inject(injectKey) as Nicotto
const messenger = useMessenger()
const category = ref<ConciergeCategory>()
const section = ref<ConciergeSection>()
const questions = ref<ConciergeQuestion[]>([])
const initial = ref<ConciergeQuestion[]>([])
nicotto.concierge.getQuestionList(props.categoryId, props.sectionId)
    .then(data => {
      questions.value = data
      initial.value = unref(questions)
    })
nicotto.concierge.getCategory(props.categoryId)
    .then(data => {
      category.value = data
    })
nicotto.concierge.getSection(props.categoryId, props.sectionId)
    .then(data => {
      section.value = data
    })
const save = async() => {
  try {
    const result = await nicotto.concierge.updateSortQuestionList(questions.value)
    if (result != null) {
      messenger.set('concierge.drag.saveSucceeded')
      isDraggable.value = false
      initial.value = questions.value
    } else {
      messenger.set('concierge.drag.saveFailed')
    }
  } catch (err) {
    console.log(err)
    messenger.set('concierge.drag.saveFailed')
  }
}

const cancel = () => {
  isDraggable.value = false
  questions.value = initial.value
}

onBeforeRouteLeave(() => {
  messenger.hide()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (category.value)
      ? (_openBlock(), _createBlock(ConciergeHeaderQuestion, {
          key: 0,
          category: category.value,
          section: section.value
        }, null, 8, ["category", "section"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ButtonLink, {
        class: "btn-primary mx-2 mb-2",
        to: `/concierge/categories/${props.categoryId}/sections/${props.sectionId}/questions/new`,
        disabled: isDraggable.value
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to", "disabled"])
    ]),
    _createVNode(_unref(draggable), {
      modelValue: questions.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((questions).value = $event)),
      "item-key": "id",
      tag: "table",
      class: "table table-bordered",
      handle: ".drag"
    }, {
      header: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (isDraggable.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_5))
              : _createCommentVNode("", true),
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ])
        ])
      ]),
      item: _withCtx(({ element }) => [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (isDraggable.value)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 0,
                  rowspan: element.processes.length,
                  class: "drag"
                }, [
                  _createVNode(IconUpDownLeftRight)
                ], 8, _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("td", {
              rowspan: element.processes.length
            }, _toDisplayString(element.name), 9, _hoisted_13),
            _createElementVNode("td", {
              rowspan: element.processes.length
            }, _toDisplayString(element.question), 9, _hoisted_14),
            (element.processes.length)
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(element.processes[0]?.condition === "yes" ? "はい" : element.processes[0].condition === "no" ? "いいえ" : "-"), 1))
              : (_openBlock(), _createElementBlock("td", _hoisted_16)),
            _createElementVNode("td", null, _toDisplayString(element.processes.length ? element.processes[0].process.name : ""), 1),
            _createElementVNode("td", null, _toDisplayString(element.processes.length ? element.processes[0].name : ""), 1),
            _createElementVNode("td", {
              rowspan: element.processes.length
            }, [
              _createVNode(ButtonLink, {
                class: "btn-primary",
                to: `/concierge/categories/${props.categoryId}/sections/${props.sectionId}/questions/${element.questionId}`,
                disabled: isDraggable.value,
                title: "編集"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconPenToSquare)
                ]),
                _: 2
              }, 1032, ["to", "disabled"])
            ], 8, _hoisted_17)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.processes.slice(1), (process, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(process.condition === "yes" ? "はい" : process.condition === "no" ? "いいえ" : "-"), 1),
              _createElementVNode("td", null, _toDisplayString(process.process.name), 1),
              _createElementVNode("td", null, _toDisplayString(process.name), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (questions.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary mx-2 mb-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isDraggable.value ? cancel() : isDraggable.value = true))
          }, _toDisplayString(isDraggable.value ? "キャンセル" : "並び替え"), 1),
          (isDraggable.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary mx-2 mb-2",
                onClick: save
              }, "確定"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(ButtonLink, {
        class: "btn-secondary mx-2 mb-2",
        to: `/concierge/categories/${props.categoryId}/sections`,
        disabled: isDraggable.value
      }, {
        default: _withCtx(() => [
          _hoisted_20
        ]),
        _: 1
      }, 8, ["to", "disabled"])
    ])
  ]))
}
}

})